<template>
  <section class="servicos-mosaico" aria-label="Nossos Serviços">
    <h2 class="titulo">Nossos Serviços</h2>
    <div class="grid-mosaico">
      <div
        v-for="servico in servicos"
        :key="servico.id"
        class="item-mosaico"
        @click="abrirModal(servico)"
      >
        <div class="imagem-container">
          <img
            :src="servico.icone"
            :alt="`Ícone de ${servico.nome}`"
            loading="lazy"
            class="imagem-servico"
          />
        </div>
        <div class="texto-servico">
          <h3>{{ servico.nome }}</h3>
          <p>{{ servico.descricao }}</p>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <transition name="fade">
      <div v-if="modalAberto" class="modal-overlay" @click.self="fecharModal">
        <div class="modal-conteudo">
          <h3>{{ servicoSelecionado.nome }}</h3>
          <img
            :src="servicoSelecionado.imagem"
            :alt="`Imagem de ${servicoSelecionado.nome}`"
            loading="lazy"
            class="modal-imagem"
          />
          <p>{{ servicoSelecionado.detalhes }}</p>

          <div class="botoes-modal">
            <a
              :href="`https://wa.me/244922488863?text=Olá, gostaria de saber mais sobre ${servicoSelecionado.nome}`"
              target="_blank"
              class="botao-consultor"
              rel="noopener"
            >
              Falar com um Consultor
            </a>
          </div>

          <button class="botao-fechar" @click="fecharModal">×</button>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: "ServicosPage",
  data() {
    return {
      servicos: [
        {
          id: 1,
          nome: "Frio e Climatização",
          descricao: "Instalação e manutenção de sistemas de refrigeração.",
          detalhes:
            "Soluções para ambientes residenciais, empresariais e automotivos. Instalação de ar-condicionado, câmaras frigorificas e sistemas de ventilação",
          icone: require("@/assets/frio.jpg"),
          imagem: require("@/assets/frio.jpg"),
        },
        {
          id: 2,
          nome: "Eletricidade Cívil e Industrial",
          descricao: "Projetos e manutenção elétrica civil industrial.",
          detalhes:
            "Serviços de instalação, manutenção, reforma e dimensionamento elétrico com foco em segurança e eficiência",
          icone: require("@/assets/eletricidade.jpg"),
          imagem: require("@/assets/eletricidade.jpg"),
        },
        {
          id: 3,
          nome: "Automação Residencial e Industrial",
          descricao: "Automação para residências e indústrias.",
          detalhes:
            "Implantação de sistemas automatizados para controle de energia, clima, iluminação, segurança e produção",
          icone: require("@/assets/automacao.jpg"),
          imagem: require("@/assets/automacao.jpg"),
        },
        {
          id: 4,
          nome: "Portas Automáticas e Acesso",
          descricao: "Instalação de portas automáticas e eletrônicas.",
          detalhes:
            "Automatização de portas e portões, sistemas de segurança e controle de acesso para diversos tipos de edificação",
          icone: require("@/assets/portas.jpg"),
          imagem: require("@/assets/portas.jpg"),
        },
        {
          id: 5,
          nome: "Manutenção de Máquinas e Motores",
          descricao: "Manutenção de máquinas elétricas e eletrônicas.",
          detalhes:
            "Diagnóstico, reparo e manutenção de equipamentos elétricos e motores industriais, com suporte técnico especializado",
          icone: require("@/assets/maquinas.jpg"),
          imagem: require("@/assets/maquinas.jpg"),
        },
      ],
      modalAberto: false,
      servicoSelecionado: null,
    };
  },
  methods: {
    abrirModal(servico) {
      this.servicoSelecionado = servico;
      this.modalAberto = true;
    },
    fecharModal() {
      this.modalAberto = false;
      this.servicoSelecionado = null;
    },
  },
};
</script>

<style scoped>
/* Container Geral */
.servicos-mosaico {
  padding: 60px 20px;
  background: linear-gradient(135deg, #f5f9ff, #e6f0fa);
  font-family: 'Segoe UI', sans-serif;
  color: #2d3748;
}

.titulo {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 40px;
  font-weight: 700;
}

/* Grid estilo mosaico */
.grid-mosaico {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}

/* Cada bloco */
.item-mosaico {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.4s ease, box-shadow 0.3s;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.item-mosaico:hover {
  transform: scale(1.03);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
}

.imagem-container {
  position: relative;
}

.imagem-servico {
  width: 100%;
  height: 350px;
  object-fit: cover;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

/* Texto fora da imagem */
.texto-servico {
  padding: 15px 12px 20px;
  background-color: transparent;
  color: #2d3748;
  text-align: left;
}

.texto-servico h3 {
  font-size: 18px;
  margin: 0;
  font-weight: 600;
}

.texto-servico p {
  font-size: 14px;
  margin-top: 6px;
  color: #4a5568;
}

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-conteudo {
  background: white;
  padding: 30px;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  text-align: center;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.modal-conteudo h3 {
  font-size: 24px;
  margin-bottom: 15px;
}

.modal-imagem {
  width: 100%;
  height: auto;
  max-height: 330px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 20px;
}

.modal-conteudo p {
  font-size: 16px;
  color: #4a5568;
  margin-bottom: 20px;
}

.botoes-modal {
  margin-bottom: 20px;
}

.botao-consultor {
  background: #25d366;
  color: white;
  padding: 12px 20px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  transition: background 0.3s;
}

.botao-consultor:hover {
  background: #1ebe57;
}

.botao-fechar {
  position: absolute;
  top: 12px;
  right: 20px;
  font-size: 26px;
  background: none;
  border: none;
  color: #4a5568;
  cursor: pointer;
}

/* Transição modal */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Responsivo */
@media (max-width: 600px) {
  .modal-conteudo {
    padding: 20px;
  }

  .modal-imagem {
    max-height: 200px;
  }
}
</style>
